import SearchableSelect from '@/Components/SearchableSelect';

export default function FormSelect({
    label,
    name,
    value = '',
    onChange,
    options = [],
    error,
    required = false,
    placeholder = 'Select...',
    disabled = false,
    searchable = false,
    labelKey = 'name',
    valueKey = 'id',
    className = '',
}) {
    return (
        <div className={className}>
            {label && (
                <label className="form-label" htmlFor={name}>
                    {label}
                    {required && <span className="text-danger ms-1">*</span>}
                </label>
            )}
            {searchable ? (
                <SearchableSelect
                    options={options}
                    value={value}
                    onChange={onChange}
                    placeholder={placeholder}
                    labelKey={labelKey}
                    valueKey={valueKey}
                    error={!!error}
                    disabled={disabled}
                />
            ) : (
                <select
                    id={name}
                    name={name}
                    className={`form-select ${error ? 'is-invalid' : ''}`}
                    value={value ?? ''}
                    onChange={(e) => onChange(e.target.value)}
                    disabled={disabled}
                >
                    <option value="">{placeholder}</option>
                    {options.map((opt) => (
                        <option key={opt[valueKey]} value={opt[valueKey]}>
                            {opt[labelKey]}
                        </option>
                    ))}
                </select>
            )}
            {error && <div className="invalid-feedback">{error}</div>}
        </div>
    );
}
